import { render, staticRenderFns } from "./otpModal.vue?vue&type=template&id=6e13d78b&scoped=true&lang=html&"
import script from "./otpModal.vue?vue&type=script&lang=js&"
export * from "./otpModal.vue?vue&type=script&lang=js&"
import style0 from "./otpModal.vue?vue&type=style&index=0&id=6e13d78b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e13d78b",
  null
  
)

export default component.exports